import React from 'react'

import {motion, useAnimation} from 'framer-motion'
import Image from 'next/image'

import {t} from '@lib/helpers'

export const Benefits = () => {
  const controls = useAnimation()
  const BENEFITS = [
    {
      icon: 'accuracy',
      title: 'accuracy.title',
      description: 'accuracy.description',
    },
    {
      icon: 'automation',
      title: 'automation.title',
      description: 'automation.description',
    },
    {
      icon: 'workflows',
      title: 'workflows.title',
      description: 'workflows.description',
    },

    {
      icon: 'customizable',
      title: 'customizable.title',
      description: 'customizable.description',
    },
    {
      icon: 'cost',
      title: 'cost.title',
      description: 'cost.description',
    },
  ]

  React.useEffect(() => {
    const element = document.querySelector('.DataLabeling__benefits')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])
  return (
    <motion.div
      className='DataLabeling__benefits'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__benefits__container'>
        <div
          className='title'
          dangerouslySetInnerHTML={{
            __html: t('pages.dataLabeling.benefits.title'),
          }}
        />
        <div
          className='sub-title'
          dangerouslySetInnerHTML={{
            __html: t('pages.dataLabeling.benefits.subtitle'),
          }}
        />
        <div className='DataLabeling__benefits__container__chart'>
          <div className='DataLabeling__benefits__container__chart__img'>
            <Image
              alt='Data Labeling'
              src='/images/services/data-labeling/chart.svg'
              width='402px'
              height='395px'
            />
          </div>

          <div className='DataLabeling__benefits__container__chart__content'>
            {BENEFITS.map((item, idx) => {
              return (
                <div key={idx} className='item'>
                  <img
                    src={`/images/services/data-labeling/${item.icon}-icon.svg`}
                  />

                  <div
                    className='title'
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `pages.dataLabeling.benefits.data.${item.title}`
                      ),
                    }}
                  />
                  <div
                    className='description'
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `pages.dataLabeling.benefits.data.${item.description}`
                      ),
                    }}
                  />
                </div>
              )
            })}
          </div>
        </div>
        <img
          src={'/images/services/data-labeling/benefits-bg.svg'}
          className='DataLabeling__benefits__container__bg'
        />
        <img
          src={'/images/services/data-labeling/benefits-bg1.png'}
          className='DataLabeling__benefits__container__bg1'
        />
        <img
          src={'/images/services/data-labeling/benefits-bg2.png'}
          className='DataLabeling__benefits__container__bg2'
        />
      </div>
    </motion.div>
  )
}
